import { render, staticRenderFns } from "./UserDataRegister.vue?vue&type=template&id=5a1aab10"
import script from "./UserDataRegister.vue?vue&type=script&lang=js"
export * from "./UserDataRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports